import { ApiKey } from '../types';

export enum MODAL_ACTION {
  CREATE_API_KEY = 'create-api-key',
  EDIT_API_KEY = 'edit-api-key',
  DELETE_API_KEY = 'delete-api-key',
  DISABLE_API_KEY = 'disable-api-key',
  VIEW_API_KEY = 'view-api-key',
}

export type CreateApiKeyResponsePayload = {
  createdAt: number;
  creatorUserId: string;
  enabled: boolean;
  jwtRequired: boolean;
  key: string;
  keyHash: string;
  keyIdentifier: string;
  keyType: string;
  name: string;
  projectId: number;
  secret: string;
  updatedAt: number;
};

export type ModalState = {
  action: MODAL_ACTION;
  apiKey?: ApiKey;
  name?: string;
  keyHash?: string;
  keyIdentifier?: string;
  createResponsePayload?: CreateApiKeyResponsePayload;
};

// KeyType reflects what is returned by the server in the /i/apiKeyTypes endpoint
export type KeyType = {
  label: string;
  value: string;
  type: string;
  description: string;
  dataTest: string;
  disabled: boolean;
};

export const NAME = 'name';
export const KEY_TYPE = 'keyType';
export const JWT_REQUIRED = 'jwtRequired';
export const CUSTOM_EVENT_MANAGE_ALLOW_CREATION = 'customEventManageAllowCreation';
export const CUSTOM_EVENT_MANAGE_ALLOW_CREATION_UNTIL = 'customEventManageAllowCreationUntil';

export const MAX_ALLOW_UNTIL_DAYS = 14;

export const CUSTOM_EVENT_ALLOW_CREATION_OPTIONS = [
  {
    name: 'Block event track calls from creating new event definitions',
    id: 'block',
    value: false,
  },
  {
    name: 'Allow event track calls to create new event definitions until',
    id: 'allow',
    value: true,
  },
];

export const SECURITY_FIX_ROLLOUT_DATE = '2022-08-29 00:00:00.000000';
